import Schema, { optional } from 'AppReact/schema';
import { approvalCategory } from 'types';

const category = {
  category_id: optional('integer'),
  amount: optional('number'),
  category_idError: optional('string'),
  amountError: optional('string'),
};

export default {
  category: Schema(category, 'object', { defaultValue: { category_id: null, amount: null, category_idError: null, amountError: null } }),
  categories: Schema(approvalCategory, 'array', { defaultValue: [] }),
  displayDelete: Schema('boolean', 'primitive', { defaultValue: false }),
  localValue: Schema('string', 'primitive', { defaultValue: '' })
}